import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_3 = { class: "flex justify-end" }

import { BryntumGrid } from "@bryntum/grid-vue-3";
import { Store } from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import {TableType} from "@/utilities/enums/Enums";



export default /*@__PURE__*/_defineComponent({
  __name: 'ActivitySetLocationsPopup',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();


const grid = ref(null);
const useGridConfig = {
  headerMenuFeature: false,
  autoHeight : true,
  columns :{
    data: [
      {
        id: 'locationId',
        field : 'locationId',
        text: t('popups.locations.id'),
        sortable: true
      },
      {
        id: 'locationName',
        field : 'locationName',
        text: t('popups.locations.name'),
        flex   : 1,
        sortable: true
      }
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.activitySetLocations], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
}

const gridConfig = reactive(useGridConfig);


onMounted(async () => {
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  gridStore.setStoreData(globalStore.modal.contentObject.activitySetLocationInfo);

  globalStore.reorderColumns(TableType[TableType.activitySetLocations]);
})

onBeforeUnmount(()=>{
  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(GridInputFilter), {
            gridStore: _unref(gridStore),
            hideFilterButton: true
          }, null, 8, ["gridStore"])
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ])
  ]))
}
}

})